var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('error-message'),_vm._v(" "),_c('sync-config'),_vm._v(" "),_c('extension-version-checker',{attrs:{"version":"2.6.0"}}),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('dialogs-wrapper',{attrs:{"wrapper-name":"default"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-417bf032","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = 0qnr
// module chunks = 1